export default __webpack_public_path__ + "f155a1ebb6c19142926e7c5e6ff5c898.png";